const translations = {
  "en": {
    "Earnings Calendar": "Earnings Calendar"
  },
  "ko": {
    "Earnings Calendar": "실적 발표 일정"
  },
  "zh": {
    "Earnings Calendar": "财报日历"
  },
  "zh-tw": {
    "Earnings Calendar": "業績日曆"
  },
  "vi": {
    "Earnings Calendar": "Lịch công bố lợi nhuận"
  },
  "es": {
    "Earnings Calendar": "Calendario de Resultados"
  },
  "tr": {
    "Earnings Calendar": "Kazanç Takvimi"
  },
  "fr": {
    "Earnings Calendar": "Calendrier des résultats"
  }
};

export default translations;
